<template>
    <div class="modal-card" style="width: auto">
        <header class="modal-card-head">
            <p class="modal-card-title">
                <b-icon icon="user"></b-icon>
                Modification concernant {{ salarie }}
            </p>
        </header>
        <section class="modal-card-body">

          <div class="columns">
            <div class="column">

          <b-progress
              type="is-info"
              :value="freeDays().reserved"
              :max="freeDays().max"
              show-value
          >
            {{ freeDays().free }} jours libres
          </b-progress>

            <b-field label="Nombre de jours">
                <b-input type="number" min="0" step="0.5" v-model="daysSaisie">
                </b-input>
            </b-field>

            <b-field label="Tâche">
                <b-input
                    type="text"
                    v-model="commentSaisie"
                    placeholder="Commentaire"
                    maxlength="90"
                >
                </b-input>
            </b-field>

            <b-field label="Coût jour spécifique">
                <b-input type="number" v-model="customcostSaisie">
                </b-input>
            </b-field>
            </div>
            <div class="column">

              <!--
              <br>
              <b-field>
                <b-slider
                    v-model="months"
                    :min="1"
                    :max="12"
                    :step="1"
                    ticks
                    tooltip-always

                >
                </b-slider>
              </b-field>
              -->

              <b-field label="Début de la tâche">
                <b-datepicker
                    v-model="startSaisie"
                    show-week-number
                    locale="fr-FR"
                    placeholder="Sélectionner"
                    icon="calendar"
                    icon-right="pen"
                    icon-right-clickable
                    @icon-right-click="clearDate('start')"
                    trap-focus>
                </b-datepicker>
              </b-field>

              <b-field label="Fin de la tâche">
                <b-datepicker
                    v-model="endSaisie"
                    show-week-number
                    locale="fr-FR"
                    placeholder="Sélectionner"
                    icon="calendar"
                    icon-right="pen"
                    icon-right-clickable
                    @icon-right-click="clearDate('end')"
                    trap-focus>
                </b-datepicker>
              </b-field>

            </div>
          </div>

        </section>
        <footer class="modal-card-foot">
            <button class="button" type="button" @click="$parent.close()">
                Annuler
            </button>
            <button class="button is-primary" @click="editTodo">Enregistrer</button>
        </footer>
    </div>
</template>

<script>
export default {
    name: "TodoEditModal",
    props: {
        salariesFree: {
          type: Array,
          required: true
        },
        days: {
            type: Number,
            required: true
        },
        uuid: {
            type: String,
            required: true
        },
        comment: {
            type: String,
            required: true
        },
        customcost: {
            type: Number,
            required: false
        },
        salarie: {
            type: String,
            required: true
        },
        start: {
          type: Date,
          required: false
        },
        end: {
          type: Date,
          required: false
        }
    },
    data() {
        return {
            daysSaisie: 0,
            commentSaisie: '',
            customcostSaisie: null,
            startSaisie: null,
            endSaisie: null,
            months: []
        }
    },
    mounted() {
        this.daysSaisie = this.days;
        this.commentSaisie = this.comment;
        this.customcostSaisie = this.customcost;
        this.startSaisie = new Date(this.start);
        this.endSaisie = new Date(this.end);
        this.months[0] = this.startSaisie.getMonth() + 1
        this.months[1] = this.endSaisie.getMonth() + 1
        console.log(this.months);
    },
    methods: {
        dateSlider() {
          let startMonth = this.months[0]-1;
          let endMonth = this.months[1]-1;
          const lastDay = new Date(2026, endMonth + 1, 0).getDate();
          this.startSaisie = new Date(2026, startMonth, 1);
          this.endSaisie = new Date(2026, endMonth, lastDay);
        },
        clearDate(d) {
          if (d === 'start') {
            console.log("clear")
            this.startSaisie = null;
          } else {
            this.endSaisie = null;
          }
        },
        freeDays() {
          const f = this.salariesFree.filter(i => i.name === this.salarie)
          return {
            free : (f[0].daystospend - f[0].days).toFixed(2),
            max: f[0].daystospend,
            reserved : f[0].days
          }
        },
        editTodo() {
            if (
                parseFloat(this.daysSaisie) >= 0
                && this.checkStringChar(this.commentSaisie)
            ) {
                const payload = {
                    uuid: this.uuid,
                    salarie: this.salarie,
                    days: Math.round(this.daysSaisie * 2) / 2,
                    comment: this.commentSaisie,
                    customcost: this.customcostSaisie,
                    start: this.startSaisie,
                    end: this.endSaisie
                };
                this.$emit("edit-todo", payload);
            } else {
                this.$buefy.snackbar.open(
                    {
                        message: `Nombre de jours non-sélectionnés ou caractères non autorisés`,
                        type: 'is-danger',
                        position: 'is-bottom-left'
                    });
            }


        }
    }
};
</script>

<style scoped></style>
